import { useCallback, useMemo } from "react";
import { useAuth } from "../../../app/providers/AuthProvider";
import { canWithRoles, resolveStaffRoles } from "../permissions";

/**
 * Gating de UI del panel super-admin según los roles de staff (TASK-20/22).
 *
 * ⚠️ SOLO UX — el backend es la autoridad. Ver el docblock de `../permissions.js`.
 *
 *   const { can } = useStaffPermissions();
 *   {can("companies", "create") && <Button>+ Registrar academia</Button>}
 */
function useStaffPermissions() {
  const { user } = useAuth();

  const staffRoles = useMemo(() => resolveStaffRoles(user), [user]);

  const can = useCallback(
    (resource, action) => canWithRoles(staffRoles, resource, action),
    [staffRoles]
  );

  const hasRole = useCallback(
    (role) => staffRoles.includes(role),
    [staffRoles]
  );

  return {
    staffRoles,
    can,
    hasRole,
    isPlatformAdmin: staffRoles.includes("PLATFORM_ADMIN"),
    /** El backend dijo explícitamente "eres staff, sin ningún rol asignado". */
    hasNoStaffRole: staffRoles.length === 0,
  };
}

export { useStaffPermissions };
